// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"55ccef37031ba928aa43","453":"5cfdd515157a28397293","522":"f45a5e3c899ac24755bd"}[chunkId] + ".js";
};